// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__hWsfp","checkboxCol":"Table_checkboxCol__rSUIu","emailCol":"Table_emailCol__1Exjs","actionCol":"Table_actionCol__2Tigd"};